import React from 'react';
import HttpSelector from './HttpSelector';


const PerspectiveSelector = ({
  workflowId,
  perspectiveId
}: any) => (
  <HttpSelector
    url={`/automatic/workflows/${workflowId}/perspectives/`}
    objectType="perspective"
    selectedObjectId={perspectiveId}
    getUrl={(_perspectiveId: any) => `/workflows/${workflowId}/perspectives/${_perspectiveId}`}
  />
);

export default PerspectiveSelector;
